module.exports = __webpack_public_path__ + "img/milestone__2004.598f030a.jpg";